export const en = {
  login: {
    title: 'Welcome to Slash',
    subTitle: 'Start using the platform',
    slides: {
      slide1: {
        title: 'Unlock your\nAI potential.',
      },
    },
    loginForm: {
      signIn: 'Login',
      signUp: 'Sign up',
      newUser: 'Is your company not registered yet?',
    },
  },
};
